import { render, staticRenderFns } from "./BulkDeleteButton.vue?vue&type=template&id=129fdcc2&"
import script from "./BulkDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./BulkDeleteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports